// components/PreEmployment/PatientInfoCard.tsx

import React from "react";
import type { PatientInfoCardProps } from "../../../types/preEmployment.types";

const PatientInfoCard: React.FC<PatientInfoCardProps> = ({ constanteData }) => {
  return (
    <div className="p-6 md:p-8 bg-gray-50 border-b">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-3">
            Informations Patient
          </h3>
          <div className="space-y-2 text-sm">
            <p>
              <span className="font-medium">Nom complet:</span>{" "}
              <span
                className={
                  constanteData.patient.lastName === "Nom non défini"
                    ? "text-red-600"
                    : "text-gray-900"
                }
              >
                {constanteData.patient.lastName}
              </span>
            </p>
            <p>
              <span className="font-medium">Date de naissance:</span>{" "}
              <span
                className={
                  constanteData.patient.dateOfBirth === "Date non définie"
                    ? "text-red-600"
                    : "text-gray-900"
                }
              >
                {constanteData.patient.dateOfBirth}
              </span>
            </p>
            <p>
              <span className="font-medium">Lieu de naissance:</span>{" "}
              <span
                className={
                  constanteData.patient.birthPlace === "Lieu non défini" ||
                  constanteData.patient.birthPlace === "Nouakchott, Mauritanie"
                    ? "text-orange-600"
                    : "text-gray-900"
                }
              >
                {constanteData.patient.birthPlace}
              </span>
            </p>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-3">
            Informations Examen
          </h3>
          <div className="space-y-2 text-sm">
            <p>
              <span className="font-medium">Date d'examen:</span>{" "}
              {constanteData.examinationDate}
            </p>
            <p>
              <span className="font-medium">Médecin:</span>{" "}
              <span
                className={
                  constanteData.doctor.firstName === "Dr" &&
                  constanteData.doctor.lastName === "Docteur"
                    ? "text-red-600"
                    : "text-gray-900"
                }
              >
                {constanteData.doctor.title} {constanteData.doctor.firstName}{" "}
                {constanteData.doctor.lastName}
              </span>
            </p>
            <p>
              <span className="font-medium">N° Certificat:</span>{" "}
              <span className="text-blue-600 font-mono text-sm">
                {constanteData.certificateNumber}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientInfoCard;
